import { cpUrl } from "content";

export default [
  {
    isShared: false,
    type: "Register Live",
    url: `${cpUrl}/register/forex/live`
  },
  {
    isShared: false,
    type: "Register Demo",
    url: `${cpUrl}/register/forex/demo`
  },
  {
    isShared: true,
    type: "Register Sub IB",
    url: `${cpUrl}/register/forex/ib`
  }
];
